import _ from 'lodash';

import buildingsWizardRoutes from '../buildingsWizard/RouteConfig';

export default _.assign({
    cpLocationsAndBuildings: {
        parent: 'baseTransactionWizard',
        template: '<div ui-view></div>'
    }
}, buildingsWizardRoutes);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/config/RouteConfig.js
// module id = 1837
// module chunks = 0